/**
 * @fileoverview added by tsickle
 * Generated from: pipes/work-pipes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Pipe } from '@angular/core';
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
var PETS = {
    dogs: 'Dog(s)',
    cats: 'Cat(s)',
    fish: 'Fish',
    reptile: 'Reptile(s)',
    bird: 'Bird(s)'
};
var AsHours = /** @class */ (function () {
    function AsHours() {
        this.transform = (/**
         * @param {?} duration
         * @return {?}
         */
        function (duration) { return duration.toFixed(1); });
    }
AsHours.ɵfac = function AsHours_Factory(t) { return new (t || AsHours)(); };
AsHours.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "asHours", type: AsHours, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AsHours, [{
        type: Pipe,
        args: [{ name: 'asHours' }]
    }], function () { return []; }, null); })();
    return AsHours;
}());
export { AsHours };
if (false) {
    /** @type {?} */
    AsHours.prototype.transform;
}
var AsPet = /** @class */ (function () {
    function AsPet() {
        this.transform = (/**
         * @param {?} petCode
         * @return {?}
         */
        function (petCode) { return PETS[petCode]; });
    }
AsPet.ɵfac = function AsPet_Factory(t) { return new (t || AsPet)(); };
AsPet.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "asPet", type: AsPet, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AsPet, [{
        type: Pipe,
        args: [{ name: 'asPet' }]
    }], function () { return []; }, null); })();
    return AsPet;
}());
export { AsPet };
if (false) {
    /** @type {?} */
    AsPet.prototype.transform;
}

